import axios from "@/plugins/axios";
import bookmark from "./bookmark";
import categories from "./categories";
import spaces from "./spaces";
import like from "./like";
import estimateInquiries from "./estimate-inquiries";

let url = "/api/v1/portfolios";
export default {
    bookmark,
    categories,
    spaces,
    like,
    estimateInquiries,

    getPortfolios(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    getPortfolio(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    putPortfolio(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
};
